module.exports = __webpack_public_path__ + "static/video-poster-188b4e14602dd056f2d9f49989fa66f6.png";